<template>
  <div class="ImpactNoData">
    <div class="ImpactNoData__icon"></div>
    <p class="ImpactNoData__message">
      No data available for this Research Topic
    </p>
  </div>
</template>
<style lang="scss">
.ImpactNoData {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;

  &__icon {
    width: 24px;
    height: 24px;
    margin: 3px 0;

    &:before {
      content: "\e981";
      font-family: $fontIcon;
      font-size: 24px;
    }
  }

  &__message {
    @include f-16-300;
    color: $textPrimary;
  }
}
</style>
